import type { TSelectBase } from 'types/general.types';

export const intents: TSelectBase[] = [
  { value: 'fallback', label: 'Fallback' },
  { value: 'affirm', label: 'Affirm' },
  { value: 'already_told_you', label: 'Already Told You' },
  { value: 'apology', label: 'Apology' },
  { value: 'contact_info', label: 'Contact Info' },
  { value: 'continue_previous', label: 'Continue Previous' },
  { value: 'decline', label: 'Decline' },
  { value: 'dont_know', label: 'Dont Know' },
  { value: 'everything', label: 'Everything' },
  { value: 'gibberish', label: 'Gibberish' },
  { value: 'goodbye', label: 'Goodbye' },
  { value: 'greet', label: 'Greet' },
  { value: 'how_are_you', label: 'How Are You' },
  { value: 'misclicked', label: 'Misclicked' },
  { value: 'no_example', label: 'No Example' },
  { value: 'nothing', label: 'Nothing' },
  { value: 'positive_expectation', label: 'Positive Expectation' },
  { value: 'profanity', label: 'Profanity' },
  { value: 'query_change_language', label: 'Query Change Language' },
  { value: 'query_clarify', label: 'Query Clarify' },
  { value: 'query_compensation', label: 'Query Compensation' },
  { value: 'query_contact_info', label: 'Query Contact Info' },
  { value: 'query_continue_later', label: 'Query Continue Later' },
  { value: 'query_data_processing_evaluation', label: 'Query Data Processing Evaluation' },
  { value: 'query_end_interview', label: 'Query End Interview' },
  { value: 'query_go_back', label: 'Query Go Back' },
  { value: 'query_human_operator', label: 'Query Human Operator' },
  { value: 'query_job_info', label: 'Query Job Info' },
  { value: 'query_next_steps', label: 'Query Next Steps' },
  { value: 'query_num_questions', label: 'Query Num Questions' },
  { value: 'query_phone', label: 'Query Phone' },
  { value: 'query_restart_interview', label: 'Query Restart Interview' },
  { value: 'query_reuse_interview', label: 'Query Reuse Interview' },
  { value: 'query_skip_question', label: 'Query Skip Question' },
  { value: 'query_system_praise', label: 'Query System Praise' },
  { value: 'query_visa_sponsorship', label: 'Query Visa Sponsorship' },
  { value: 'query_who_is_hubert', label: 'Query Who Is Hubert' },
  { value: 'resume_expand', label: 'Resume Expand' },
  { value: 'resume_see', label: 'Resume See' },
  { value: 'resume_send', label: 'Resume Send' },
  { value: 'statement', label: 'Statement' },
  { value: 'system_complaint', label: 'System Complaint' },
  { value: 'system_praise', label: 'System Praise' },
  { value: 'technical_issues', label: 'Technical Issues' },
  { value: 'thanks', label: 'Thanks' },
];
